import { createGlobalStyle } from "styled-components";
import { dalCustomColors } from "./dalCustomColors";

export const dalGlobalCSS = createGlobalStyle`
  body {
    font-family: "FFF AcidGrotesk";
  }
  
  h1, .h1 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.headingsDark};
    font-size: 80px;
    font-weight: 700;
    line-height: 97px;
  } 
  
  h2, .h2 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.headingsDark};
    font-size: 50px;
    font-weight: 700;
    line-height: 49px;
  }
  
  h3, .h3 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.headingsDark};
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
  }
  
  p, .body1 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.body1Dark};
    font-size: 16px;
    font-weight: 400;
    line-height: 27px;
  }
  
  .body1semibold {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.body1Dark};
    font-size: 16px;
    font-weight: 600;
    line-height: 27px;
  }
  
  .body2 {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.body2Dark};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  
  .body2semibold {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.body2Dark};
    font-size: 14px;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
  }

  .applicationCaption {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.captionGrey};
  }
  
  .caption {
    font-family: "FFF AcidGrotesk";
    color: ${dalCustomColors.body1Dark};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }

  .applicationDateChip {
    color: ${dalCustomColors.body1Dark}; //TODO: If confirmed, put in shade of jobCategory
    background-color: ${dalCustomColors.fieldBackgroundColor};
    border:  1px solid ${dalCustomColors.borderColor};
  }

  .kanbanColumnHeader {
    background-color: ${dalCustomColors.white};
  }

  .hrBotMultipleButton {
    background-color: ${dalCustomColors.white};
    border-radius: 4px;
    border: 1px solid ${dalCustomColors.borderColor};
    color: ${dalCustomColors.primary};
  }

  .historyLine {
    border-bottom: 1px solid ${dalCustomColors.borderColor}
  }

  .customNumberField {
    background-color: ${dalCustomColors.fieldBackgroundColor};
    border-bottom: 1px solid ${dalCustomColors.primary};
    border-top: 1px solid transparent;
  }

  .sideBar {
        border-right: 1px solid ${dalCustomColors.borderColor};
        background-color: ${dalCustomColors.fieldBackgroundColor};
    }

  .noteHeader {
      border-bottom: 1px solid ${dalCustomColors.borderColor};
  }

  .disabled {
    opacity: 0.15;
  }

  .topImageHeader {
      color: ${dalCustomColors.white}
  }

  .loginSite {
        background-color: ${dalCustomColors.fieldBackgroundColor}; 
    }

  .notification {
      border-bottom: 1px solid ${dalCustomColors.borderColor};
  }

  .comment {
    border-bottom: 1px solid ${dalCustomColors.borderColor};
  }
`;
